import { Grid } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import {
  addTheme,
  addEFG,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import EfgOverView from "./efgAdminOverView";
import ThemeCustomization from "./themeCustomization";
// import FilterTable from '../components/filtertable';
import { useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import toast from "react-hot-toast";
import http from "../services/httpService";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function EfgTabs({ tabName }) {
  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = React.useState(0);
  const [dialog, setDialog] = React.useState(false);
  const [otpField, setotpField] = React.useState("");
  let history = useHistory();
  const [loadTabs, setLoadTabs] = React.useState(false);

  const addEfgButton = (e) => {
    e.preventDefault();
    history.push({
      pathname: addEFG,
      otp: otpField,
    });
  };

  const addThemeButton = (e) => {
    e.preventDefault();
    history.push(addTheme);
  };

  const handleOTP = (e) => {
    setotpField(e.target.value);
    // console.log(otpField, "OTP");
  };

  const handleOTPRequest = (row) => {
    setDialog(true);

    const actionobj = {
      Action: "Add Question",
      Section: "EFG Questions",
    };

    http
      .post("/verification_view", actionobj)
      .then((res) => {
        toast.success("OTP Sent Successfully!");
      })
      .catch((err) => {
        toast.error("OTP Request Failed!");
      });
  };

  const handleChange = (event, newValue) => {
    // setAddTab(addPage[newValue])
    setValue(newValue);
  };
  let tabsList = ["Efg Questions", "Theme Customization"];
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");

    if (tabName) {
      let tab =
        tabsList.indexOf(tabName) !== -1 ? tabsList.indexOf(tabName) : 0;
      setValue(tab);
    } else {
      setValue(0);
    }
    setLoadTabs(true);
  }, []);
  return (
    <div>
      <Grid container style={{ marginTop: 20 }} className={"pb30"}>
        <Grid item xs={12} sm={0} md={0} lg={4}></Grid>
        <Grid item xs={12} sm={8} md={8} lg={6}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            {tabsList.map((text, index) => (
              <Tab
                label={text}
                key={index}
                {...a11yProps(index)}
                style={{ borderRadius: 10 }}
              />
            ))}
          </Tabs>
        </Grid>

        <Grid item xs={12} sm={4} md={3} lg={2} className={"efgBtn"}>
          <Button
            color="primary"
            style={
              value == 0
                ? { display: "block", float: "right", lineHeight: "unset" }
                : { display: "none" }
            }
            variant="contained"
            // onClick={(e) => addEfgButton(e)}
            onClick={handleOTPRequest}
          >
            Add Question
          </Button>
          <Button
            color="primary"
            style={
              value == 1
                ? { display: "block", float: "right", lineHeight: "unset" }
                : { display: "none" }
            }
            variant="contained"
            onClick={(e) => addThemeButton(e)}
          >
            Add Theme
          </Button>
        </Grid>
      </Grid>
      {loadTabs ? (
        <>
          <TabPanel value={value} index={0}>
            <EfgOverView />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ThemeCustomization />
          </TabPanel>
        </>
      ) : (
        ""
      )}
      <Dialog
        open={dialog}
        onClose={(e) => setDialog(false)}
        aria-labelledby="draggable-dialog-delete"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
          Edit Question
        </DialogTitle>
        <DialogContent>
          <span>Do you want to Add Question?</span>
          <p>Enter OTP</p>

          <input placeholder="OTP" onChange={handleOTP}></input>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setDialog(false)} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={addEfgButton}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default EfgTabs;
